var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilterMobileIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.75172C0 0.785226 0.783502 0.00172424 1.75 0.00172424H14.25C15.2165 0.00172424 16 0.785226 16 1.75172V4.1465C16 4.61426 15.8127 5.06255 15.48 5.39132L10.8243 9.99162C10.7768 10.0386 10.75 10.1026 10.75 10.1694V13.2911C10.75 13.9654 10.3626 14.5797 9.75407 14.8703L7.75407 15.8253C6.59262 16.3799 5.25 15.5331 5.25 14.2461V10.1694C5.25 10.1026 5.22325 10.0386 5.17571 9.99162L0.519995 5.39132L1.04714 4.85783L0.519995 5.39132C0.187264 5.06255 0 4.61426 0 4.1465V1.75172ZM1.75 1.50172C1.61193 1.50172 1.5 1.61365 1.5 1.75172V4.1465C1.5 4.21332 1.52675 4.27736 1.57429 4.32433L6.23 8.92463C6.56274 9.2534 6.75 9.70169 6.75 10.1694V14.2461C6.75 14.4299 6.9418 14.5509 7.10772 14.4717L9.10773 13.5167C9.19465 13.4752 9.25 13.3874 9.25 13.2911V10.1694C9.25 9.70169 9.43726 9.2534 9.76999 8.92463L14.4257 4.32433C14.4732 4.27736 14.5 4.21332 14.5 4.1465V1.75172C14.5 1.61365 14.3881 1.50172 14.25 1.50172H1.75Z",
    fill: "#FCF8FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilterMobileIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/filter-mobile-icon.179111925a071d884e8379d9e25e0f31.svg";